// hooks
import useAuth from 'src/hooks/useAuth';
// utils
import createAvatar from 'src/utils/createAvatar';
//
import Avatar from './Avatar';
import useCompany from 'src/hooks/useCompany';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();
  const { companyDetail } = useCompany();

  return (
    <Avatar
      src={companyDetail?.logo || user?.photo}
      alt={user?.displayName}
      color={user?.photo ? 'default' : createAvatar(user?.displayName).color}
      {...other}
    >
      {createAvatar(user?.displayName).name}
    </Avatar>
  );
}
